export enum PurchaseSessionStep {
  ACCOUNT = 'account',
  PRODUCTS = 'products',
  PAYMENT = 'payment',
  CONFIRM = 'confirm',
}

export const PURCHASE_SESSION_STEPS: Record<PurchaseSessionStep, string> = {
  [PurchaseSessionStep.ACCOUNT]: 'Account',
  [PurchaseSessionStep.PRODUCTS]: 'Prodotti',
  [PurchaseSessionStep.PAYMENT]: 'Pagamento',
  [PurchaseSessionStep.CONFIRM]: 'Conferma', 
};